import { FetchWrapper } from "../infrastructure/fetch-wrapper";
import { IBasicCommandResponse } from "./ah.mb.client-notifications";

//export interface IPublishToDashboardModel {
//    modelIds: Array<string>;
//    nodePathAndName: string;
//    setName: string;
//    resultType: string;
//    format: string;
//    query: string;
//}

export interface IDashboardExport {
    resultType: string;
    query: string;
    nodePathAndNames: Array<string>;
    customFieldDefs: Array<string>;
}

export interface IDashboardPublishDefinition {
    name: ""
    modelId: string;
    setName: string;
    exports: Array<IDashboardExport>
    customFieldDefs: Array<string>;
}


export class DashboardServices {

    //// Creares a new model
    //publishReportResultsToDashboard = (model: IPublishToDashboardModel): Promise<IBasicCommandResponse> => {

    //    return FetchWrapper.sendCommandAndHandle("/api/1.0/dashboard/publish",
    //        { method: "post", body: JSON.stringify(model) });

    //}

    publishReportResultsToDashboard = (model: IDashboardPublishDefinition): Promise<IBasicCommandResponse> => {

        return FetchWrapper.sendCommandAndHandle("/api/1.0/dashboard/publish",
            { method: "post", body: JSON.stringify(model) });

    }

}


// WEBPACK FOOTER //
// ./ClientApp/scripts/dashboardServices.ts